import { defineAsyncComponent } from "vue";

export default {
  forms: {
    edit: {
      panel: {
        width: "80%",
      },
      component: defineAsyncComponent(() => import("./forms/Edit.vue")),
    },
    list: {
      component: defineAsyncComponent(() => import("./forms/List.vue")),
    },
    select: {
      config: {
        sorting: true,
        fields: {
          name: {},
          order: {
            config: {
              sorting: "forms.order",
            },
          },
          created_at: {},
          updated_at: {},
        },
      },
    },
  },
};
